import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

const AppProviders = lazy(() => import('@app/components/AppProviders'));
const FileUploadErrorModal = lazy(() => import('./FileUploadErrorModal'));

class FileUploadErrorModalComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['is-open', 'error-messages'];
    }

    render() {
        const isOpen = this.prop('is-open') === 'true';
        const errorMessages = this.jsonProp<string[]>('error-messages');

        return (
            <AppProviders>
                <FileUploadErrorModal isOpen={isOpen} errorMessages={errorMessages ?? []} />
            </AppProviders>
        );
    }
}

customElements.define('file-upload-error-modal', FileUploadErrorModalComponent);
